export default function StepGuides(props) {
  return (
    <div 
      className = "services-item fullWidth" 
      data-aos="fade-right" 
    >
      <div className = "services-content">
        <h1>Per concludere l'attivazione completare i seguenti passi: </h1>

        <hr />

        <h2>
          1. Scarica o apri il PDF compilabile del contratto da qui:
          <br />
          <div className = "pill colorOk"> 
            <a target = "_blank" href = 'https://olisys.it/files/Contratti/Olisys_Contratto_Privati_Wired.pdf'> 
              Contratto compilabile (PDF)
            </a>
          </div> 
        </h2>
        
        <br />
        
        <h2>
          2. Compilare il modulo scegliendo come servizio: { props.serviceName }
        </h2>
        
        <br />
        
        <h2>
          3. Stampare il documento compilato e firmarlo.
        </h2>
        
        <br />
        
        <h2>
          4. Inviare il contratto firmato e la copia f/r della carta di identità a: 
          <br />
          <a href = 'mailto:amm.ne@olisys.it'> amm.ne@olisys.it </a>
        </h2>
        
        <br />
        
        <h2>
          5. Sarai contattato ai recapiti da te forniti, per concordare l'installazione.
        </h2>

        <hr />
        
        <p>
          Ti ricordiamo che è necessario, al fine di poter attivare il servizio, consegnare anche il contratto cartaceo originale,
          insieme alla copia del documento di identità. 
          <br/>
          La consegna potrà essere fatta a mano direttamente al tecnico installatore, 
          oppure recapitando i documenti, o spedendoli per posta ordinaria, presso la nostra sede 
          all'indirizzo: Olisys snc, Via Raffaello 16/L – 01100 Viterbo (VT)
          <br />
          La mancata consegna della documentazione porterà alla sospensione 
          momentanea del servizio di installazione e dell'erogazione, fino al momento del completamento
          della pratica amministrativa in essere delle due parti.
        </p>
      </div>
    </div>
  );
}



